import { Badge, Text } from "@mantine/core";
import { IconPill } from "@tabler/icons-react";
import React from "react";
import { getSkypointMarCompletion } from "../../../services/skypointAlerts";
import SkypointAlertsTablePage from "./SkypointAlertsTablePage";

const columns = [
  {
    key: "provider",
    header: "Provider",
    render: (item) => (
      <Text weight={500} size="sm">
        {item.providerName}
      </Text>
    ),
  },
  {
    key: "schedule",
    header: "MAR Rule Active",
    width: 160,
    render: (item) => (
      <Badge
        variant="light"
        size="sm"
        color={item.marScheduleActive ? "green" : "gray"}
      >
        {item.marScheduleActive ? "Active" : "Off"}
      </Badge>
    ),
  },
  {
    key: "missing",
    header: "Missing Doses",
    width: 160,
    render: (item) => (
      <Badge
        color={
          item.missingMAR === 0
            ? "green"
            : item.missingMAR >= 50
              ? "red"
              : item.missingMAR >= 10
                ? "orange"
                : "yellow"
        }
        variant="light"
        size="sm"
      >
        {item.missingMAR}
      </Badge>
    ),
  },
];

const MarCompletion = ({ isSidebarOpen }) => (
  <SkypointAlertsTablePage
    isSidebarOpen={isSidebarOpen}
    title="MAR Completion"
    description="Medication administration coverage per provider, last 30 days"
    Icon={IconPill}
    iconColor="#12B76A"
    iconBg="#ECFDF3"
    columns={columns}
    stateSelector={(state) => state?.skypointAlerts?.marCompletion}
    fetcher={getSkypointMarCompletion}
    emptyMessage="No MAR data across linked providers."
    itemUnit="provider"
  />
);

export default MarCompletion;
